export const licenseTypes = {
  GET_LICENSE: 'GET_LICENSE',
  GET_RECEIPTS: 'GET_RECEIPTS',
  DOWNLOAD_RECEIPT: 'DOWNLOAD_RECEIPT',
}
